/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Scheduled_Sync_WeeklyInputs */



/**
* | output |
* | --- |
* | "Weekly" |
*
* @param {Spaces_Scheduled_Sync_WeeklyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_scheduled_sync_weekly = /** @type {((inputs?: Spaces_Scheduled_Sync_WeeklyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Scheduled_Sync_WeeklyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wöchentlich")
	return /** @type {LocalizedString} */ ("Weekly")
});